import React from 'react';
import Banner from '../home-3/Banner';
import FeatureOne from '../home-3/FeatureOne';
import ScheduleThree from '../home-3/ScheduleThree';
import TeamOne from '../home-3/TeamOne';
import BuyTicket from '../home-3/BuyTicket';
import TicketOne from '../home-3/TicketOne';
import Brand from '../home-3/Brand';
import BlogOne from '../home-3/BlogOne';
import CTAOne from '../home-3/CTAOne';


const HomeThreeMain = () => {
	return (
		<>
			<Banner />
			<FeatureOne />
			<ScheduleThree />
			<TeamOne />
			<BuyTicket />
			<TicketOne />
			<Brand />
			<BlogOne />
			<CTAOne />
		</>
	);
}

export default HomeThreeMain;
